import {useOnboardingSlider} from "./useOnboardingSlider";
import {SliderNavigation} from "./SliderNavigation";
import "./OnboardingSlider.scss";

export const OnboardingSlider = () => {
    const {slides, currentIndex, switchSlide, isVisible} = useOnboardingSlider();

    const {src, title, body} = slides[currentIndex];

    return (
        <div className="OnboardingSlider">
            <div className={`OnboardingSlider-slide${isVisible ? ' is-visible' : ''}`}>
                <img src={src} alt={`${title} slide`} />
                <SliderNavigation switchSlide={switchSlide} currentIndex={currentIndex}/>
                <h1>{title}</h1>
                <p>{body}</p>
            </div>
        </div>
    )
}